import type { ApiClient } from "@/lib/api";
import type { McpServer, McpServerCreateRequest } from "../types";

export const createMcpGateway = async (options: {
  client: ApiClient;
  payload: McpServerCreateRequest;
}): Promise<McpServer> => {
  const { client, payload } = options;
  const { data } = await client.post<McpServer>("/gateways", payload);
  return data;
};
